import React from 'react';

import {useI18n} from '@udemy/i18n';
import {SpotIllustration} from '@udemy/illustrations';
import {Button} from '@udemy/react-core-components';
import {Modal} from '@udemy/react-dialog-components';
import {TakeOverWizard} from '@udemy/react-structure-components';

import styles from '../pop-quiz-modal.module.less';
import {LONG_SNOOZE_DAYS} from './constants';
import {renderUdemyLogo} from './utils';

interface PopQuizSnoozedPhaseProps {
    isOpen: boolean;
    onClose: () => void;
}

export function PopQuizSnoozedPhase({isOpen, onClose}: PopQuizSnoozedPhaseProps) {
    const {gettext, interpolate} = useI18n();

    return (
        <Modal
            isOpen={isOpen}
            title=""
            renderTitle={() => [
                'pop-quiz-snoozed-label',
                <span key="t" id="pop-quiz-snoozed-label" className="ud-sr-only">
                    {gettext('Pop quiz')}
                </span>,
            ]}
            className={styles['quiz-modal']}
            requireExplicitAction={true}
        >
            <TakeOverWizard
                fullScreenHeight={false}
                headerProps={{
                    renderLogo: renderUdemyLogo,
                    centerChildren: gettext('Knowledge check'),
                    rightChildren: (
                        <Button udStyle="ghost" size="medium" onClick={onClose}>
                            {gettext('Exit')}
                        </Button>
                    ),
                }}
                footerProps={{
                    rightChildren: (
                        <Button udStyle="primary" size="medium" onClick={onClose}>
                            {gettext('Close')}
                        </Button>
                    ),
                }}
            >
                <div className={styles['snoozed-content']}>
                    <SpotIllustration name="growth" width={120} height={120} alt="" />
                    <p className="ud-text-md">
                        {interpolate(
                            gettext("You won't be shown pop quizzes for the next %(days)s days."),
                            {days: LONG_SNOOZE_DAYS},
                            true,
                        )}
                    </p>
                </div>
            </TakeOverWizard>
        </Modal>
    );
}
